export default __webpack_public_path__ + "static/media/05-identify-non-customers.b61b132e.svg";